document.addEventListener('DOMContentLoaded', function(dom) {
  const notification = dom.target.querySelector('.part-notification')
  let notificationIsClose = JSON.parse(sessionStorage.getItem('notification-is-close'))
  if (notification) {
    const notificationClose = notification.querySelector(
      '.js-close-notification',
    )
    if (notificationClose) {
      if (notificationIsClose) {
        notification.style.display = 'none'
      }
      notificationClose.addEventListener('click', function(e) {
        sessionStorage.setItem('notification-is-close', 'true')
        notification.style.display = 'none'
        notificationIsClose = true
      })
    }

  }
})
